'use strict';

/**
 * UI Admin — action « Générer l'expédition » (B2.4b1).
 */

export function canShowGenerateExpeditionButton(commande, { boxtalShippingOrderEnabled } = {}) {
  if (!commande || commande.modeRetrait !== 'expedition') return false;
  if (!boxtalShippingOrderEnabled) return false;
  const shipment = commande.shipment;
  if (!shipment?.id) return false;
  if (String(shipment.status || '').toUpperCase() !== 'DRAFT') return false;
  if (shipment.providerShipmentId) return false;
  if (shipment.provider === 'BOXTAL') return false;
  return true;
}

export function expeditionShippingOrderErrorMessage(code) {
  switch (code) {
    case 'SHIPPING_PROVIDER_CREATE_ALREADY_CLAIMED':
    case 'PROVIDER_CREATE_OUTCOME_UNKNOWN':
      return 'Création déjà engagée. Ne relancez pas l\'envoi.';
    case 'SHIPPING_ORDER_FEATURE_DISABLED':
      return 'Création transporteur désactivée sur ce environnement.';
    case 'BOXTAL_PRODUCTION_ORDER_DISABLED':
      return 'Création transporteur production interdite.';
    default:
      return null;
  }
}
